import React from 'react';
import { Box} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import BGP from '../Assets/oldpaper.jpg';

function BackgroundOld() {

    const matches = useMediaQuery('(min-width:1000px)');

    return (
        <Box sx={{display:'flex',backgroundOrigin:'border-box', backgroundRepeat:'no-repeat',
            backgroundPosition:'center',justifyContent:'center'}}>
                <img src={BGP} style={{
                        opacity:'0.6',             
                     objectFit:'cover',
                     position:'fixed',
                     width:'100%',
                     height:'100%',
                     zIndex:-1
                     }}/>
              
                    </Box>
    );
  }
  
  export default BackgroundOld;